import React from "react";
import { Radio } from "antd";

const RadioGroup = ({
	defaultValue,
	dispatch,
	name,
	lookup,
	isNew,
	questionId,
	dataType,
	...otherProps
}) => {
	const [answerAdded, answerEdited] = dispatch;
	const onChange = (e) => {
		let data = {
			questionId: questionId,
			value: e.target.value,
			id: name,
			dataType: dataType,
		};
		if (!isNew) answerEdited(data);
		else answerAdded(data);
	};
	return lookup ? (
		<Radio.Group value={defaultValue} onChange={onChange} {...otherProps}>
			{lookup.map((p) => (
				<Radio key={p.code} value={p.code}>
					{p.description}
				</Radio>
			))}
		</Radio.Group>
	) : (
		<p>Error: a radio group was rendered but no lookup list was passed</p>
	);
};

export default RadioGroup;
